/** True when auto-start for this session id should be skipped (already failed this page load). */
export function shouldBlockLobbyAutoStart(
  sessionId: string,
  blocked: ReadonlySet<string>
): boolean {
  return sessionId.length > 0 && blocked.has(sessionId);
}

/** True when a session GET should be treated as gone / inaccessible for lobby auto-start. */
export function isStaleSessionFetch(status: number, error?: string): boolean {
  if (status === 404 || status === 403) return true;
  return error === "not_found" || error === "forbidden";
}
